import React from 'react';

import {
    Typography
} from '@material-ui/core';

import EmojiPeopleIcon from '@material-ui/icons/EmojiPeopleOutlined'

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 150,
        padding: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
    },
    image: {
        display: 'inline-block',
        marginTop: 50,
        width: '200px',
        height: '200px'
    }
}));

export const NotFoundPage = (props) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Typography align="center" variant="h2">
                404: La pagina che cerchi non esiste
            </Typography>
            <br />
            <Typography align="center" variant="body1">
                Hai manipolato l'indirizzo o sei venuto qui per errore. In ogni caso, usa la navigazione
            </Typography>
            <br />
            <EmojiPeopleIcon className={classes.image} />
        </div>
    );
}